import { useEffect, useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
  MenuItem,
} from '@mui/material';

import { getPostVisitMemberMap } from "../../../../../utils/services/APP/PostVisit/getPostVisitMemberMap";
import { YesNoSelector } from './Table/YesNoSelector';


const FormulationPostVisit = ({ modificar = {}, onSave}) => {
  const timestamp = new Date().toLocaleString(); 
  const [Patients, setPatients] = useState([]);

  
  const [form, setForm] = useState({
    memberID: modificar.memberID || '',
    PostVisitID: modificar.PostVisitID || '',
    TimeStamp: modificar.TimeStamp || '',
    MemberName: modificar.MemberName || '',
    MemberPhoneNumber: modificar.MemberPhoneNumber || '',
    MemberMobileNumber: modificar.MemberMobileNumber || '',
    Location: modificar.Location || '',
    PcpName: modificar.PcpName || '',
    DateOfService: modificar.DateOfService || '',
    Comments: modificar.Comments || '',
    Staff: modificar.Staff || '',
    DidThePatientAnswer:modificar.DidThePatientAnswer || '',
    AppointmentType: modificar.AppointmentType || '',
    HowWasYourVisitWithTheDoctor: modificar.HowWasYourVisitWithTheDoctor || '',
    WereYouPrescribedAnyMedocatopms: modificar.WereYouPrescribedAnyMedocatopms || '',
    DidTheDoctorOrderLabsToBeDone: modificar.DidTheDoctorOrderLabsToBeDone || '',
    DOB: modificar.DOB
  });

  useEffect(() => {
    const PatientsData = getPostVisitMemberMap()
    setPatients(PatientsData.data);
  }, []);

    const handleChange = (field, value) => {
        setForm(prev => ({ ...prev, [field]: value }));
    };

    const MemberSelect = (value) => {
      
      const selectedPatient = Patients.find(p => p.memberID === value);
    if (selectedPatient) {
      setForm(prev => ({
        ...prev,
        memberID: selectedPatient.memberID,
        MemberName: selectedPatient.MemberName,
        MemberMobileNumber: selectedPatient.MemberMobileNumber,
        MemberPhoneNumber: selectedPatient.MemberPhoneNumber,
        DOB: selectedPatient.DOB,
        Location: selectedPatient.Location,
        Staff: selectedPatient.Staff
      }));
  }
    };
    const handleSubmit = () => {
        const newSystemicBilling = {
        ...form
        };
        if(newSystemicBilling.PostVisitID == ''){
          newSystemicBilling.PostVisitID = crypto.randomUUID(); 
        }
        newSystemicBilling.TimeStamp = timestamp;
        onSave(newSystemicBilling);
    };

  function formatToInputDate(dateStr) {
    if (!dateStr) return '';
    const [month, day, year] = dateStr.split('/');
    if (!month || !day || !year) return '';
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }

  function formatToUSDate(inputDate) {
    if (!inputDate) return '';
    const [year, month, day] = inputDate.split('-');
    return `${parseInt(month, 10)}/${parseInt(day, 10)}/${year}`;
  }

  return (
    <Container maxWidth="xl">
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">Post Visit Form</Typography>
      </Box>
      <Paper variant="outlined" sx={{ p: 4, mb: 3 }}>
        <Grid container spacing={2}>
          <Grid item width="100%"><Typography><strong>Member Name:</strong></Typography></Grid>
          <TextField
            select
            fullWidth
            value={form.memberID || ''} // Asegúrate de tener este campo
            onChange={e => MemberSelect(e.target.value)}
          >
            {Patients.map(opt => (
              <MenuItem key={opt.memberID} value={opt.memberID}>
                {opt.MemberName}
              </MenuItem>
            ))}
          </TextField>
          <Grid item width="100%"><Typography><strong>DOB:</strong></Typography></Grid>
          <TextField
              disabled
              fullWidth
              value={form.DOB}
          ></TextField>
          <Grid item width="100%"><Typography><strong>Member Phone Number:</strong></Typography></Grid>
          <TextField
              disabled
              fullWidth
              value={form.MemberPhoneNumber}
          ></TextField>
          <Grid item width="100%"><Typography><strong>Location:</strong></Typography></Grid>
          <TextField
              disabled
              fullWidth
              value={form.Location}
          ></TextField>
          <YesNoSelector
            label="Did The Patient Answer?"
            name="DidThePatientAnswer"
            value={form.DidThePatientAnswer}
            onChange={(name, option) =>handleChange(name, option)}
        />
        <Grid item width="100%"><Typography><strong>Pcp Name:</strong></Typography></Grid>
          <TextField
              fullWidth
              value={form.PcpName}
              onChange={e => handleChange('PcpName', e.target.value)}
          ></TextField>
        <Grid item width="100%"><Typography><strong>Date Of Service:</strong></Typography></Grid>
          <TextField
              fullWidth
              type="Date"
              value={formatToInputDate(form.DateOfService)}
              onChange={e => handleChange('DateOfService', formatToUSDate(e.target.value))}
          ></TextField>
        <Grid item width="100%"><Typography><strong>Appointment Type:</strong></Typography></Grid>
        <TextField
            fullWidth
            value={form.AppointmentType}
            onChange={e => handleChange('AppointmentType', e.target.value)}
        ></TextField>
        <YesNoSelector
            label="How Was Your Visit With The Doctor?"
            name="HowWasYourVisitWithTheDoctor"
            value={form.HowWasYourVisitWithTheDoctor}
            options={["Very Satisfied", "Satisfied","Dissatisfied"]}
            onChange={(name, option) =>handleChange(name, option)}
        />
        <YesNoSelector
            label="Were you prescribed any medications?"
            name="WereYouPrescribedAnyMedocatopms"
            value={form.WereYouPrescribedAnyMedocatopms}
            onChange={(name, option) =>handleChange(name, option)}
        />
        <YesNoSelector
            label="Did the doctor order labs to be done?"
            name="DidTheDoctorOrderLabsToBeDone"
            value={form.DidTheDoctorOrderLabsToBeDone}
            onChange={(name, option) =>handleChange(name, option)}
        />
        <Grid item width="100%"><Typography><strong>Comments:</strong></Typography></Grid>
          <TextField
              fullWidth
              value={form.Comments}
              onChange={e => handleChange('Comments', e.target.value)}
          ></TextField>
          <Grid item width="100%"><Typography><strong>Staff:</strong></Typography></Grid>
          <TextField
              disabled
              fullWidth
              value={form.Staff}
          ></TextField>
          <Grid item width="100%"><Typography><strong>TimeStamp:</strong></Typography></Grid>
          <TextField
              disabled
              fullWidth
              value={form.TimeStamp != '' ? form.TimeStamp: timestamp }
          ></TextField>
        </Grid>
        
        <Button 
            fullWidth
            variant="contained"
            sx={{ 
                mt: 2, // espacio arriba (theme spacing * 2 = 16px)
                backgroundColor: '#bdbdbd',
                color: 'black',
                '&:hover': { backgroundColor: '#9e9e9e' }
            }}
            onClick={handleSubmit}
            >
            <Typography sx={{ color: '#117a65' }}>Save</Typography>
        </Button>
      </Paper>
    </Container>
  );
};

export default FormulationPostVisit;
